import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@utex/ui-kit';
import { borderBottom, Icon, marginBottom } from './styles';
import turtle from './static/turtle.svg';

interface Props {
  onRetry: () => void;
}

export const ErrorPanel: React.FC<Props> = ({ onRetry }) => {
  const { t } = useTranslation('withdraw');
  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      flexGrow={1}
    >
      <Icon src={turtle} alt={t('Something went wrong')} />
      <Typography.Title level={2} size={{ all: 'XL', phonablet: 'XL' }} css={borderBottom}>
        {t('Something went wrong')}
      </Typography.Title>

      <Typography.Text size={{ all: 'M', phonablet: 'M' }} css={marginBottom}>
        {t('Retry later please')}
      </Typography.Text>
      <Button view="extra-dim" onClick={onRetry} size="M">
        {t('Try again')}
      </Button>
    </Box>
  );
};
